<script setup lang="ts">
import { PV } from "@/widgets";
import Icon from "~icons/prime/times";

defineEmits<{
    click: [];
}>();
</script>

<template>
    <PV.Button v-tooltip.left="'Reset'" class="p-0!" link unstyled @click="$emit('click')">
        <Icon class="text-gray-400 hover:text-gray-700 hover:cursor-pointer" />
    </PV.Button>
</template>
